// extracted by mini-css-extract-plugin
module.exports = {"cropBox":"style_cropBox__1bMDd","cropOper":"style_cropOper__3wX8C","cols":"style_cols__1fWrh","btn":"style_btn__d2Fnv","label":"style_label__1ipcy"};